import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

import { overviewFontBuilderCss } from "../OverviewDataResults/OverviewDataResults.style";

const { ui } = constants.colors;

const darkBlue700 = ui.core[700];
const darkGrey700 = ui.neutral[700];

export const sidebarTitleCss: CSSObject = {
  margin: "0",
  ...overviewFontBuilderCss({
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "800",
    lineHeight: "133%",
  }),
  color: darkGrey700,
  textTransform: "uppercase" as const,
  letterSpacing: "1px",
};

export const listNavigationItemsContainerCss = {
  listStylePosition: "inside" as const,
  padding: "4px 8px 4px 0px",
};

export const listNavigationItemCss = ({
  isActive,
  isSubmenuLink,
  isBold,
}: {
  isActive: boolean;
  isSubmenuLink: boolean;
  isBold?: boolean;
}): CSSObject => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    listStyleType: "none",
    position: "relative" as const,
    marginBottom: "2px",
    marginLeft: "-16px",
    width: "calc(100% + 32px)",

    ...overviewFontBuilderCss({
      fontSize: "14px",
      fontStyle: "normal",
      lineHeight: "171%",
    }),

    a: {
      textDecoration: "none",
      color: "inherit",
      fontWeight: isBold ? "700" : "400",
      width: "100%",
      padding: "6px",
      paddingLeft: isSubmenuLink ? "32px" : "16px",
      borderRadius: "8px",
      backgroundColor: isActive ? "white" : "transparent",

      ":hover": {
        backgroundColor: "white",
      },
    },

    "::before": isActive
      ? {
          content: '""',
          position: "absolute" as const,
          width: "4px",
          height: "24px",
          left: "4px",
          borderRadius: "8px",
          backgroundColor: darkBlue700,
        }
      : {},

    "> *": {
      width: "100%",
    },
  };
};
